import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6073cf45&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style1 from "./index.vue?vue&type=style&index=1&id=6073cf45&lang=less"
import style2 from "./index.vue?vue&type=style&index=2&id=6073cf45&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073cf45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6073cf45')) {
      api.createRecord('6073cf45', component.options)
    } else {
      api.reload('6073cf45', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6073cf45&scoped=true", function () {
      api.rerender('6073cf45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/index.vue"
export default component.exports